import { addLocaleData } from 'react-intl-legacy';
import cs from 'react-intl-legacy/locale-data/cs';
import da from 'react-intl-legacy/locale-data/da';
import de from 'react-intl-legacy/locale-data/de';
import en from 'react-intl-legacy/locale-data/en';
import es from 'react-intl-legacy/locale-data/es';
import et from 'react-intl-legacy/locale-data/et';
import fi from 'react-intl-legacy/locale-data/fi';
import fr from 'react-intl-legacy/locale-data/fr';
import hu from 'react-intl-legacy/locale-data/hu';
import is from 'react-intl-legacy/locale-data/is';
import it from 'react-intl-legacy/locale-data/it';
import ja from 'react-intl-legacy/locale-data/ja';
import ko from 'react-intl-legacy/locale-data/ko';
import nl from 'react-intl-legacy/locale-data/nl';
import no from 'react-intl-legacy/locale-data/no';
import pl from 'react-intl-legacy/locale-data/pl';
import pt from 'react-intl-legacy/locale-data/pt';
import ro from 'react-intl-legacy/locale-data/ro';
import ru from 'react-intl-legacy/locale-data/ru';
import sk from 'react-intl-legacy/locale-data/sk';
import sv from 'react-intl-legacy/locale-data/sv';
import tr from 'react-intl-legacy/locale-data/tr';
import uk from 'react-intl-legacy/locale-data/uk';
import vi from 'react-intl-legacy/locale-data/vi';
import zh from 'react-intl-legacy/locale-data/zh';

let hasAlreadyAdded = false;

// initiated supported locale data for usage with react-intl. This should be done only once
export const addSuportedLocaleData = () => {
    if (hasAlreadyAdded) {
        return;
    }
    addLocaleData([
        ...en,
        ...de,
        ...es,
        ...fr,
        ...ja,
        ...ko,
        ...pt,
        ...ru,
        ...cs,
        ...fi,
        ...hu,
        ...it,
        ...no,
        ...ro,
        ...sk,
        ...zh,
        ...da,
        ...et,
        ...is,
        ...nl,
        ...pl,
        ...sv,
        ...vi,
        ...uk,
        ...tr,
    ]);
    hasAlreadyAdded = true;
};

// get language from locale for usage with react-intl. For eg: en_US => en
export const getLanguageFromLocale = (locale: string | undefined | null) => {
    if (locale && locale.trim()) {
        if (locale === 'pt_BR' || locale === 'pt-BR') {
            return 'pt-BR';
        }
        return locale.split('_')[0].split('-')[0].trim();
    }

    // default to 'en'
    return 'en';
};
